/**
 * Helper function to check if a value is null or undefined.
 * Replacement for deprecated util.isNullOrUndefined from Node.js
 */
export function isNullOrUndefined(value: unknown): value is null | undefined {
    return value === null || value === undefined;
}
